// src/theme.ts
export type Theme = 'light' | 'dark';

export const palette = {
  light: {
    bgPrimary: '#dfeaf8',
    bgSidebar: '#d6e3f3',
    bgChatInput: '#ffffff',
    bgCard: '#f3f7ff',
    textPrimary: '#233b67',
    textSecondary: '#4b648a',
    borderSoft: '#c6d6f0',
    accent: '#40b0ff',
    sidebarDivider: '#b9cce7',
    userMenuBg: '#ffffff',
    userMenuHover: '#f4f6fb',
    icon: '#233b67',
    chatInputPlaceholder: '#8ba0c0',
    mainLogoSrc: '/src/assets/logo-full-light.png',
    sidebarLogoSrc: "/src/assets/logo-sidebar-light.png",
  },
  dark: {
    bgPrimary: '#050b16',
    bgSidebar: '#050b16',
    bgChatInput: '#151b26',
    bgCard: '#151b26',
    textPrimary: '#f4f7ff',
    textSecondary: '#c3d0e8',
    borderSoft: '#202636',
    accent: '#40b0ff',
    sidebarDivider: '#1b2334',
    userMenuBg: '#050b16',
    userMenuHover: '#111827',
    icon: '#f4f7ff',
    chatInputPlaceholder: '#7b879b',
    mainLogoSrc: '/src/assets/logo-full-dark.png',
    sidebarLogoSrc: "/src/assets/logo-sidebar-dark.png",
  }
} satisfies Record<Theme, Record<string, string>>;

export type Palette = typeof palette.light;

function detectSystemTheme(): Theme {
  if (typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
}

function loadTheme(): Theme {
  const saved = localStorage.getItem('theme');
  if (saved === 'dark' || saved === 'light') return saved;
  return detectSystemTheme();
}

// tema actual — persiste entre refrescos via localStorage
export let currentTheme = $state({value: loadTheme()});

// Escuchar cambios en la preferencia del SO si no hay selección manual
if (typeof window !== 'undefined') {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
    const saved = localStorage.getItem('theme');
    if (!saved) {
      currentTheme.value = e.matches ? 'dark' : 'light';
    }
  });
}

export function getTheme() {
  return currentTheme.value;
}

export function setTheme(t: Theme) {
  currentTheme.value = t;
  localStorage.setItem('theme', t);
}

export function toggleTheme() {
  const next = currentTheme.value === 'light' ? 'dark' : 'light';
  currentTheme.value = next;
  localStorage.setItem('theme', next);
}

export function getPalette() {
  return palette[currentTheme.value];
}